<template>
  <div class="user-info">
    <img src="~@/assets/def_avatar_84px.png" class="avatar" alt="">
    <div class="con">
      <div class="name">{{user.name}}</div>
      <div :class="['tag '+ statusClass]">{{user.statusText}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "userInfo",
    props: {
      user: {
        type: Object,
        default: () => {
          return {
            name: '未登录',
            statusText: '审批中'
          }
        }
      }
    },
    computed: {
      // businessStatus  1:正在处理 2:撤销 3:驳回 4:已结束
      statusClass() {
        let Obj = {
          1: 'ing',
          2: 'dis',
          3: 'err',
          4: 'suc'
        }
        return Obj[this.user.businessStatus]
      }
    },
  }
</script>
<style scoped lang="scss">
  .user-info {
    padding-top: 30px;
    display: flex;
    align-items: center;
    .avatar{
      width: 64px;
      height: 64px;
      margin-right: 16px;
    }
    .name{
      font-family: PingFang SC, PingFang SC;
      font-size: 16px;
      color: #2F3030;
      line-height: 22px;
      margin-bottom: 12px;
    }
    .tag{
      height: 28px;
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      padding: 0 12px;
      display: inline-flex;
      align-items: center;
      &::before{
        display: inline-block;
        content: '';
        background-color: currentColor;
        width: 8px;
        height: 8px;
        border-radius: 8px;
        margin-right: 8px;
      }
    }
    .ing{
      background-color: #FCF7E4;
      color: #F5C401;
    }
    .suc{
      background-color: #E4F7F4;
      color: #00B498;
    }
    .err{
      background-color: #FCE9EC;
      color: #E23C58 ;
    }
    .dis{
      background-color: #F7F7F7;
      color: #C5C9C9;
    }
  }
 
</style>